import './vendor';
import './helpers';
import './components/social';
import {ieFix} from './vendor/ie-fix';
import {vhFix} from './vendor/vh-fix';
import {actualYear} from './modules/actualYear';
import header from './components/header';
import Tabs from './components/Tabs';
import headerTwo from './components/header-2';
import sliders from './components/sliders';
import dropdown from './components/dropdown';
import lazyLoading from './modules/lazyLoading';
import scrollToAnchor from './modules/scrollToAnchor';
import dates from './components/dates';
import booking from './components/booking';
import bookingTabs from './components/bookingTabs';
import modals from './components/modals';
import map from './components/map';
import phoneMask from './components/phone-mask';

ieFix();
vhFix();
actualYear();

map.init();

scrollToAnchor.init();

modals.init();

header.init();
headerTwo.init();
lazyLoading.init();
dates.init();

sliders.init();
dropdown.init();
booking.init();
bookingTabs.init();
phoneMask.init();

$('textarea').keyup(function () {
	if (this.value.length > 1000) {
		this.value = this.value.substr(0, 1000);
	}
});

const animateStar = (elem) => {
	setTimeout(() => $(elem).addClass('filled'), 100);
};

$(document).on('click', '.reviews__star', function () {
	const current = $(this).index();
	const wrap = $(this).closest('.reviews__stars');
	const stars = wrap.find('.reviews__star');
	const input = wrap.find('.reviews__input');
	const arr = [];

	if (current == 0) {
		$(this).addClass('filled');
	}

	// заполнить до выбранной
	for (let i = 0; i < current; i++) {
		arr.push($(stars).eq(i));
	}

	arr.push($(stars).eq(current));
	arr.forEach((elem, i) => {
		setTimeout(() => animateStar(elem), 50 * i);
	});
	input.val(arr.length);

	// убрать заполнение у звёзд после выбранной
	for (let i = current + 1; i < stars.length + 1; i++) {
		$(stars).eq(i).removeClass('filled');
	}
});

$('.center-page .first__filter-input').on('change', function () {
	const val = $(this).val();
	const scrollTop = $(`.${val}`)[0].getBoundingClientRect().top;
	const headerHeight = $('.header').height();

	window.scrollTo({
		top: scrollTop - headerHeight,
		behavior: 'smooth',
	});
});

$('.input__change').on('click', function () {
	$(this).closest('form').find('.hidden').removeClass('hidden');
});

$('.info__form button:not(.info__form-submit)').on('click', (e) => {
	return false;
});

$('.visit__tabs-item-input').on('change', function () {
	const val = $(this).val();

	$('.visit__content').hide(0);
	$(`.visit__content.${val}`).show();
});

if ($('.visit__tabs-item-input').length) {
	const val = $('.visit__tabs-item-input:checked').val();
	$(`.visit__content.${val}`).show();
}

const visitItems = $('.visit__item');

visitItems.each((i, item) => {
	$(item).find('.visit__item-block').on('click', () => {
		$('.visit__details').eq(i).addClass('active');
	});
});

$('.visit__details-back').on('click', function () {
	$(this).closest('.visit__details').removeClass('active');
});

$('.accounts__item-block').each((i, item) => {
	const height = $(item)[0].scrollHeight;
	$(item)[0].style.setProperty('--height', `${height}px`);
});

$('.accounts__item-arrow').on('click', function () {
	$(this).closest('.accounts__item-block').toggleClass('active');
});

$('.booking-page .tabs__item').on('click', function () {
	const target = $(this).data('target');
	$('.tabs__content section').hide(0);
	$('.tabs__item').removeClass('active');
	$(this).addClass('active');
	$(`section.${target}`).show();
});

